// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__GTw9w","lds-grid":"Spinner_lds-grid__RNLQI"};